import { defineStore } from 'pinia';
import { CompanyResource, type CatalogProduct } from '@/resources';
import { useLoginStore } from './login';
import { AsyncComputedState } from '@common/asyncComputed';
import axios from 'axios';
import { watch } from 'vue';

export const useCatalogStore = defineStore('catalog', {
  state() {
    return {
      hasEverRun: false,
      stopWatch: null as (() => void) | null,
      products: [] as CatalogProduct[],
      state: AsyncComputedState.Pending,
    };
  },

  actions: {
    async load() {
      const login = useLoginStore();
      this.state = AsyncComputedState.Updating;
      try {
        if (!login.id_azienda) {
          this.products = [];
        } else {
          this.products = await new CompanyResource().catalog(login.id_azienda).get();
        }
        this.state = AsyncComputedState.Success;
        this.hasEverRun = true;
      } catch (err) {
        this.products = [];
        this.state = AsyncComputedState.Error;

        if (!(axios.isAxiosError(err) && err.response && [401, 403, 404, 410].includes(err.response.status))) {
          throw err;
        }
      }
    },

    async init() {
      if ((this.hasEverRun && this.products.length > 0) || this.state === AsyncComputedState.Updating) {
        return;
      }

      const login = useLoginStore();
      await this.load();
      this.stopWatch ??= watch(() => login.id_azienda, this.clear);
    },

    clear() {
      this.stopWatch?.();
      this.$reset();
    }
  },
});
